<template>
    <BookingCancellationTable
        v-for="item in productCancellation.items"
        :item="item"
        :key="item.itemId" />
</template>

<script lang="ts">
    import { defineComponent, computed, PropType } from 'vue';
    import { useStore } from '@/store';
    import { ActivityProduct, HotelProduct } from '@/api/MyBooking/myBooking.interfaces';
    import { getBookingProductCancellation } from './BookingCancellation.helpers';
    import { BookingProductCancellation } from './BookingCancellation.interfaces';
    import BookingCancellationTable from './BookingCancellationTable.vue';

    export default defineComponent({
        name: 'BookingCancellation',
        components: {
            BookingCancellationTable,
        },
        props: {
            product: {
                type: Object as PropType<HotelProduct | ActivityProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const store = useStore();

            const policies = computed(
                () => store.getters['myBooking/getCancellationPolicies']
            );

            const productCancellation = computed<BookingProductCancellation>(() =>
                getBookingProductCancellation(product, policies.value)
            );

            return {
                productCancellation,
            };
        },
    });
</script>
